@if (isLoading) {
  <div class="text-center mt-5">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
@if (!isLoading && !isUrlsDisabled) {
  <div class="container" role="main">
    <div class="HmsContainer">
      <div class="row">
        <div class="row HmsInsideContainer">
          <div class="col-md-12 button-padding-left">
            @if (isInstruction) {
              <button type="button" class="greyBtn" (click)="openInstruction()"
                style="font-weight: bold;">
                Instructions
              </button>
            }
            @if (!isEmailValidatedAndSame && isFormsValid) {
              <button type="button"
                class="orangeBtn ml-5"
                (click)="openEmailVerificationModal()"
                [disabled]="isGeneratingCode"
                [ngStyle]="{'background-color': primaryColor}">
                Proceed to Email Address Verification
              </button>
            }
            @if (isEmailValidatedAndSame && isFormsValid) {
              <button type="button" class="orangeBtn ml-5"
                (click)="userDetailsSubmit()"
                [ngStyle]="{'background-color': primaryColor}">
                Proceed to Next Section
              </button>
            }
          </div>
        </div>
      </div>
      <div class="row HmsInsideContainer">
        <div class="col-md-12">
          <p role="heading" aria-level="1">Submitting Party Information</p>
        </div>
      </div>
      <ng-container #contactTextOutlet></ng-container>
      <ng-template #contactTextBlock>
        <div class="row HmsInsideContainer">
          <div class="col-md-12">
            <p role="heading" aria-level="1">
              Please enter your contact information, we may need to contact you for
              additional information or clarifications.
            </p>
          </div>
        </div>
      </ng-template>
      <div class="row HmsInsideContainer">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <form class="userForm" [formGroup]="userFormPart1">
            @if (isformloaded) {
              <div class="col-md-10">
                <app-json-form
                  [controlsData]="userFormDataPart1.controls"
                  [formData]="userFormPart1"
                  (valueChangeEvent)="valueChangeEvent($event)">
                </app-json-form>
              </div>
            }
          </form>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <form class="userForm" [formGroup]="userFormPart2">
            @if (isformloaded) {
              <div class="col-md-10">
                <app-json-form [controlsData]="userFormDataPart2.controls" [formData]="userFormPart2"
                (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
              </div>
            }
          </form>
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <form class="userForm" [formGroup]="userFormPart3">
                @if (isformloaded) {
                  <div class="col-md-10" style="width: 85% !important;">
                    <app-json-form [controlsData]="userFormDataPart3.controls" [formData]="userFormPart3"
                    (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                  </div>
                }
              </form>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <form class="userForm" [formGroup]="userFormPart4">
                @if (isformloaded) {
                  <div class="col-md-10" style="width: 65% !important;">
                    <app-json-form [controlsData]="userFormDataPart4.controls" [formData]="userFormPart4"
                    (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                  </div>
                }
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (!isLoading && isUrlsDisabled) {
  <div class="container" role="main">
    <div class="row main-home py-0">
      <div class="col-md-12">
        <h1 role="heading" aria-level="1">Please verify the URL that you are attempting to access.</h1>
      </div>
    </div>
  </div>
}

<ng-template #emailVerificationModal let-modal>
  <div class="modal-header custom-modal-header">
    <h4 class="modal-title">Email Verification</h4>
    <button type="button" class="closebtn rounded" (click)="closeEmailVerificationModal()">Cancel</button>
  </div>

  <div class="modal-body custom-modal-body">
    <app-re-captcha (captchaEvent)="onCaptchaResolved($event)"></app-re-captcha>

    @if (captchaValidated) {
      <div class="verification-content" >
        <p class="text-left">
          You will receive a six-digit verification code from fraudcapture&#64;gainwelltechnologies.com,
        </p>
        <p class="text-left">
          please enter that code in the field below and click the Submit button:
        </p>
        <div class="input-submit-wrapper">
          <input type="text" maxlength="6" inputmode="numeric" [(ngModel)]="verificationCode"
            (keypress)="allowOnlyNumbers($event)" class="form-control code-input"
            [ngClass]="{ 'invalid-shadow': !isCodeValid() }" placeholder="Enter the 6-Digit Code Here" />
            <button type="button" class="orangeBtn submit-btn" (click)="submitVerificationCode()"
              [disabled]="!verificationCode || verificationCode.length !== 6"
              [ngStyle]="{'background-color': primaryColor}">
              Submit
            </button>
          </div>
          @if (verificationErrorMessage) {
            <div class="text-danger mt-2">
              {{ verificationErrorMessage }}
            </div>
          }
          <div class="mt-5">
            <p class="text-left">
              If you did not receive a code, please correct your email address or click:
            </p>
            <button class="closebtn rounded resend-btn" (click)="resendCode()">Resend Code</button>
          </div>
        </div>
      }
    </div>
  </ng-template>
